import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { businessChain, chainClose } from '@/mocks/jiuchou-chain';

export default function ChainDemo() {
  const [started, setStarted] = useState(false);
  const [stage, setStage] = useState(0);
  const [step, setStep] = useState(0);

  const currentStage = businessChain[stage];
  const currentStep = currentStage.steps[step];

  if (!started) {
    return (
      <section className="w-full bg-background-50 py-20 md:py-28">
        <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
          <Reveal>
            <SectionHeading
              eyebrow="一条业务主链"
              title="一件商品，如何走完一条价值链？"
              subtitle="六个阶段、三十个环节，从供应商创建商品，到数字货架、云社员分发、消费者购买、平台清分，最终驱动产业增值。"
            />
          </Reveal>
          <Reveal delay={100}>
            <button
              onClick={() => setStarted(true)}
              className="mt-10 inline-flex items-center gap-3 px-10 py-4 rounded-full bg-primary-500 text-background-50 font-heading font-bold text-lg whitespace-nowrap cursor-pointer transition-all hover:bg-primary-600 hover:scale-[1.03]"
            >
              <i className="ri-play-circle-line text-2xl"></i>
              开始演示
            </button>
          </Reveal>
        </div>
      </section>
    );
  }

  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        {/* 阶段选择 */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
          {businessChain.map((s, i) => (
            <button
              key={s.no}
              onClick={() => {
                setStage(i);
                setStep(0);
              }}
              className={`p-4 rounded-lg border text-left cursor-pointer transition-all ${
                i === stage
                  ? 'border-primary-500 bg-primary-50'
                  : 'border-background-200 bg-background-100 hover:border-primary-300'
              }`}
            >
              <div className="flex items-center gap-2">
                <div
                  className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                    i === stage ? 'bg-primary-500' : 'bg-background-50 border border-background-200'
                  }`}
                >
                  <i className={`${s.icon} ${i === stage ? 'text-background-50' : 'text-foreground-500'} text-base`}></i>
                </div>
              </div>
              <div className="mt-2 text-xs font-semibold text-foreground-950 whitespace-nowrap">
                {s.no}
              </div>
              <div className="text-xs text-foreground-500 mt-0.5">{s.title}</div>
            </button>
          ))}
        </div>

        {/* 当前阶段详情 */}
        <div className="mt-10 rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className={`${currentStage.icon} text-background-50 text-2xl`}></i>
            </div>
            <div>
              <div className="text-xs font-medium text-foreground-500">{currentStage.no}</div>
              <h3 className="font-heading font-bold text-xl text-foreground-950">
                {currentStage.title}
              </h3>
            </div>
            <span className="ml-auto px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs whitespace-nowrap">
              {currentStage.actor}
            </span>
          </div>

          {/* 步骤流程 */}
          <div className="mt-8 flex flex-wrap items-center gap-2">
            {currentStage.steps.map((s, i) => (
              <div key={s.id} className="flex items-center gap-2">
                <button
                  onClick={() => setStep(i)}
                  className={`px-4 py-2.5 rounded-md text-sm whitespace-nowrap cursor-pointer transition-all border ${
                    i === step
                      ? 'bg-primary-500 text-background-50 border-transparent font-semibold'
                      : 'bg-background-50 border-background-200 text-foreground-700 hover:border-primary-300'
                  }`}
                >
                  {s.label}
                </button>
                {i < currentStage.steps.length - 1 && (
                  <i className="ri-arrow-down-line text-foreground-400 text-sm hidden sm:block"></i>
                )}
              </div>
            ))}
          </div>

          {/* 步骤详情 */}
          <div className="mt-6 p-5 rounded-lg bg-background-50 border border-background-200">
            <div className="flex items-center gap-2 font-heading font-bold text-foreground-950">
              <span className="w-6 h-6 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-xs">
                {step + 1}
              </span>
              {currentStep.label}
            </div>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{currentStep.detail}</p>
          </div>
        </div>

        {/* 底部闭环 */}
        <div className="mt-10 text-center">
          <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-medium">
            <i className="ri-loop-left-line text-primary-300"></i>
            最终形成：{chainClose}
          </div>
          <div className="mt-4">
            <button
              onClick={() => setStarted(false)}
              className="px-5 py-2 rounded-md border border-background-200 text-foreground-600 text-sm cursor-pointer hover:border-primary-300 hover:text-primary-600 transition-colors"
            >
              重新演示
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}